module.exports = __webpack_public_path__ + "static/media/eco-ecology-house-svgrepo-com.b71b2ce0.svg";